/** @module csi/widget/FormGroupContainer */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/form/_FormMixin",
	"underscore",
	"csi/html",
	"csi/widget/FormGroupProperties",
	"csi/widget/FormGroupSelection",
	
], function(declare,_TemplatedMixin,_WidgetBase,_FormMixin,_,html,FormGroupProperties,FormGroupSelection){
	/** 
	 * @typedef {Object} SelectionParam -  an object containing required parameters to create FormGroupSelection widget
	 * @property {boolean} active - if true, checkbox will not render
	 * @property {string} checkboxLabel - the label for the checkbox
	 * @property {string} currentValueLabel - the label for current value text box
	 * @property {string} currentValue - current value 
	 * @property {string} currentAdditionalText
	 * @property {string} dropdownLabel - the label for drop down widget
	 * @property {string} name - serve as key for the widget when _FormMixin get("value") function is called
	 * @property {Store} store - the store for drop down widget
	 * @property {string} value - value of the widget
	 */

	return declare([_WidgetBase,_TemplatedMixin,_FormMixin], {
		templateString: '<div class="${baseClass}" data-dojo-attach-point="containerNode">' +
			'<div class="${baseClass}-selection-container" data-dojo-attach-point="selectionsNode"></div>' +
			'<div class="${baseClass}-properties-container" data-dojo-attach-point="propertiesNode"></div>' + 
			'<div class="${baseClass}-additional-container" data-dojo-attach-point="additionalNode"></div>' + 
		'</div>',

		baseClass: "csi-form-group-container",

		/** @property {SelectionParam[]} selectionList - array of widget param object to render FromGroupSelection */
		selectionList: null,

		/** @property {Object<string, string>} propertyList -  the object of properties to render FromGroupProperties */
		propertyList: null,

		/** @property {Widget} additionalWidget - the widget to show after propertyList*/
		additionalWidget: null,
	
		/**
		 * @override
		 * Render the properties to the list box
		 */
		postCreate: function() {
			this.inherited(arguments);
			this._addSelections(this.selectionList);
			this._addProperties(this.propertyList);
			if (this.additionalWidget) {
				this.additionalWidget.placeAt(this.additionalNode);
			}
		}, 
		
		/**
		 * Add selection widget to the DOM node
		 * @param {Object} selections 
		 */
		_addSelections: function(selections) {
			_.each(selections, function(val, key) {
				var widget = new FormGroupSelection(val);
				widget.placeAt(this.selectionsNode);
			}, this);
		},

		/**
		 * Add properties list box to DOM node
		 * @param {Object} properties 
		 */
		_addProperties: function(properties) {
			if (!properties) {
				return;
			}
			new FormGroupProperties(properties).placeAt(this.propertiesNode);
		}

	});

});